import React from 'react';
import c from 'classnames';

import { useNodeStatesContext, useReactNodeView } from '@lyearn/lygo-core';

const TabsComponent: React.FC = () => {
  const { node, view, getPos, editableComponentRef } = useReactNodeView();
  const { getNodeState } = useNodeStatesContext();

  if (!node || !getNodeState || !view) {
    return null;
  }

  const parentId =
    typeof getPos === 'function' && getPos()
      ? view.state.doc.resolve(getPos()!).parent.attrs.id
      : null;

  const isActive = parentId ? getNodeState(parentId)?.activeTabId === node.attrs.id : null;

  return <div ref={editableComponentRef} className={c({ hidden: !isActive })} />;
};

export default TabsComponent;
